import { createSlice } from "@reduxjs/toolkit";

export const listSlice = createSlice({
  name: "list",
  initialState: {
    list: null,
    dropdownOptions: {},
    // shape: { listId, name, conditions, removedIds, tab, filtersEdited }
    draftListFilter: null,
    listGridSettings: {
      columns: null,
      columnFilters: null,
      sortingInfo: null,
    },
  },

  reducers: {
    setListToState: (state, action) => {
      state.list = action.payload;
    },
    setListGridSettingsToState: (state, action) => {
      state.listGridSettings = action.payload;
    },
    setDraftListFilter: (state, action) => {
      state.draftListFilter = action.payload;
    },
    clearDraftListFilter: (state) => {
      state.draftListFilter = null;
    },
  },
});

export const {
  setListToState,
  setListGridSettingsToState,
  setDraftListFilter,
  clearDraftListFilter,
} = listSlice.actions;

export const selectList = (state) => {
  return state.list;
};

export const getListInfo = (state) => {
  return state.list.list;
};

export const getLeadGridSettings = (state) => {
  return state.crmLeads.leadGridSettings;
};

export const getDraftListFilter = (state) => {
  return state.list.draftListFilter;
};

export default listSlice.reducer;
